import { Box, Flex } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import styled from "styled-components";

export const CoverageCardWrapper = styled(Box)`
  width: 100%;
  border-radius: 12px;
  border: 1px solid #e7e7f0;
  background: #fff;
  box-sizing: border-box;
  z-index: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CardHeading = styled(Text)`
  padding: 16px 16px 0px 16px;
  color: #040222;
  font-style: normal;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  @media (min-width: 768px) {
    line-height: 24px;
    font-size: 16px;
  }
`;

export const SubHeading = styled(Text)`
  padding: 2px 20px 0px 16px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: #36354c;
  .idv-span {
    text-decoration: underline;
    cursor: pointer;
    text-underline-offset: 2px;
  }
  span {
    font-weight: 500;
  }
  @media (min-width: 768px) {
    line-height: 20px;
  }
`;

export const CardSubHeading = styled(Text)`
  padding: 0px 20px 0px 16px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: #36354c;
  margin: 5px 0 16px 0;
  @media (min-width: 768px) {
    line-height: 20px;
  }
`;

export const CardContent = styled(Text)`
  padding: 0px 20px 0px 16px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: #5b5675;
  ul {
    padding-inline-start: 0px;
    margin-block-start: 0px;
    list-style-type: none;
    display: flex;
    flex-direction: column;
    gap: 12px;
    color: #040222;
  }
  @media (min-width: 768px) {
    line-height: 20px;
  }
`;
